import { lazy } from 'react';

export const PowerGrid = lazy(() => import('./PowerGrid.component'));
